export const TAG_SALESFORCE_QUOTES_FLOW = 'faf963b4-93af-4936-a832-ce381f9a3617';
